// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-expansion-panel--active[data-v-e0fbf85c] .v-expansion-panel-header{background-color:var(--v-warning-base);min-height:49px}.v-expansion-panels[data-v-e0fbf85c] .v-expansion-panel-content__wrap,.v-expansion-panels[data-v-e0fbf85c] .v-expansion-panel-header{line-height:1.3em}[data-v-e0fbf85c] .v-window iframe,[data-v-e0fbf85c] .v-window img{max-width:100%!important}[data-v-e0fbf85c] .v-window ol,[data-v-e0fbf85c] .v-window ul{padding:0 24px 0 16px!important}", ""]);
// Exports
module.exports = exports;
